import { render, staticRenderFns } from "./DisplayDateTime.vue?vue&type=template&id=71abe28d&scoped=true"
import script from "./DisplayDateTime.vue?vue&type=script&lang=js"
export * from "./DisplayDateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71abe28d",
  null
  
)

export default component.exports